import React from "react";
import {
  Checkbox,
  FormControlLabel,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import TextField from "Components/UI/TextField";
import Select from "Components/UI/Select";

export default function General({
  client,
  FORM_MODE,
  countryCodes,
  handleInputChange,
  loading,
}) {
  return (
    <>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          gap: "1rem",
        }}
      >
        <TextField
          autoFocus={true}
          name="ClientNumber"
          disabled={FORM_MODE === "LOCKED"}
          label="Klientnummer"
          value={client?.CNr}
          onChange={(e) => handleInputChange("CNr", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
        <TextField
          name="OrgNo"
          disabled={FORM_MODE === "LOCKED"}
          label="Org.nr"
          value={client?.OrgNo}
          onChange={(e) => handleInputChange("OrgNo", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
        <TextField
          name="VATRegistration"
          disabled={FORM_MODE === "LOCKED"}
          label="Momsregnummer"
          value={client?.VATRegistration}
          onChange={(e) => handleInputChange("VATRegistration", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
        <TextField
          autoFocus={true}
          name="Name"
          disabled={FORM_MODE === "LOCKED"}
          label="Namn"
          value={client?.Name}
          onChange={(e) => handleInputChange("Name", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
        <TextField
          name="Name2"
          disabled={FORM_MODE === "LOCKED"}
          label="Namn2"
          value={client?.Name2}
          onChange={(e) => handleInputChange("Name2", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
        <FormControlLabel
          control={
            <Checkbox
              disabled={FORM_MODE === "LOCKED"}
              checked={client?.FVAT}
              onChange={(event) =>
                handleInputChange("FVAT", event.target.checked)
              }
            />
          }
          label="Godkänd för F-skatt"
        />
        <TextField
          name="Address"
          disabled={FORM_MODE === "LOCKED"}
          label="Adress"
          value={client?.Address}
          onChange={(e) => handleInputChange("Address", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
        <TextField
          name="Address2"
          disabled={FORM_MODE === "LOCKED"}
          label="Adress2"
          value={client?.Address2}
          onChange={(e) => handleInputChange("Address2", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
        <TextField
          name="PostalCode"
          disabled={FORM_MODE === "LOCKED"}
          label="Postnr"
          value={client?.PostalCode}
          onChange={(e) => handleInputChange("PostalCode", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
        <TextField
          name="City"
          disabled={FORM_MODE === "LOCKED"}
          label="Ort"
          value={client?.City}
          onChange={(e) => handleInputChange("City", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
        <TextField
          name="AutoWriteOffAmount"
          disabled={FORM_MODE === "LOCKED"}
          label="Autoavskrivning"
          value={client?.AutoWriteOffAmount}
          onChange={(e) => handleInputChange("AutoWriteOffAmount", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
        <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
          <InputLabel>Land</InputLabel>
          <Select
            value={client?.CountryCode}
            disabled={FORM_MODE === "LOCKED"}
            onChange={(e) => handleInputChange("CountryCode", e.target.value)}
            name="CountryCode"
            label="Land"
            size="small"
          >
            {countryCodes?.map((country) => (
              <MenuItem key={country.Value} value={country.Value}>
                {country.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        
      </div>
      <FormControlLabel
        style={{ width: "100%" }}
        control={
          <Checkbox
            disabled={FORM_MODE === "LOCKED"}
            checked={!!Number(client.DontSendInvoiceToPrint)}
            onChange={(event) =>
              handleInputChange(
                "DontSendInvoiceToPrint",
                event.target.checked ? "1" : "0"
              )
            }
          />
        }
        label="Skriv inte ut faktura"
      />
    </>
  );
}
